// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/748338f4/" + chunkId + "." + __webpack_require__.h() + ".v748338f4.js";
};